module.exports = __webpack_public_path__ + "img/discount-sale-back.c54b7070.png";